// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.AssertionBindingKeys
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.buildCborArray
import org.multipaz.crypto.EcPublicKey
import org.multipaz.cbor.Bstr
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString

fun AssertionBindingKeys.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "e09cLB92DemxKlcHrpGY-PBX6zwVShehqc3iaw5ItjU")
val AssertionBindingKeys_cborSchemaId = ByteString(123, 79, 92, 44, 31, 118, 13, -23, -79, 42, 87, 7, -82, -111, -104, -8, -16, 87, -21, 60, 21, 74, 23, -95, -87, -51, -30, 107, 14, 72, -74, 53)

fun AssertionBindingKeys.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "BindingKeys")
    val array = this.publicKeys.let {
        buildCborArray {
            for (value in it) {
                add(value.toDataItem())
            }
        }
    }
    builder.put("publicKeys", array)
    builder.put("nonce", Bstr(this.nonce.toByteArray()))
    builder.put("clientId", Tstr(this.clientId))
    val array0 = this.keyStorage.let {
        buildCborArray {
            for (value in it) {
                add(Tstr(value))
            }
        }
    }
    builder.put("keyStorage", array0)
    val array1 = this.userAuthentication.let {
        buildCborArray {
            for (value in it) {
                add(Tstr(value))
            }
        }
    }
    builder.put("userAuthentication", array1)
    builder.put("issuedAt", this.issuedAt.toDataItemDateTimeString())
    val expiration = this.expiration
    if (expiration != null) {
        builder.put("expiration", expiration.toDataItemDateTimeString())
    }
    return builder.end().build()
}

fun AssertionBindingKeys_fromDataItem(dataItem: DataItem): AssertionBindingKeys {
    val array2 = dataItem["publicKeys"].let {
        buildList<EcPublicKey> {
            for (value in it.asArray) {
                add(EcPublicKey.fromDataItem(value))
            }
        }
    }
    val publicKeys = array2
    val nonce = ByteString(dataItem["nonce"].asBstr)
    val clientId = dataItem["clientId"].asTstr
    val array3 = dataItem["keyStorage"].let {
        buildList<String> {
            for (value in it.asArray) {
                add(value.asTstr)
            }
        }
    }
    val keyStorage = array3
    val array4 = dataItem["userAuthentication"].let {
        buildList<String> {
            for (value in it.asArray) {
                add(value.asTstr)
            }
        }
    }
    val userAuthentication = array4
    val issuedAt = dataItem["issuedAt"].asDateTimeString
    val expiration0 = if (dataItem.hasKey("expiration")) {
        dataItem["expiration"].asDateTimeString
    } else {
        null
    }
    return AssertionBindingKeys(
        publicKeys = publicKeys,
        nonce = nonce,
        clientId = clientId,
        keyStorage = keyStorage,
        userAuthentication = userAuthentication,
        issuedAt = issuedAt,
        expiration = expiration0,
    )
}
